import { Request, RequestHeaders } from '../../../httpClient/serverApi/requests/Request';
import { IGetMetricDataPointsByIdsParams } from '../types/IGetMetricDataPointsByIdsParams';
import { IMetricDataList } from '../types/IMetricDataList';

export type GetMetricDataPointsByIdsParams = IGetMetricDataPointsByIdsParams;

export class GetMetricDataPointsByIdsRequest extends Request<GetMetricDataPointsByIdsParams, IMetricDataList> {
  constructor(params: GetMetricDataPointsByIdsParams, headers?: RequestHeaders) {
    super('getMetricDataPointsByIds', params, headers);
  }
}
